import { Toast } from '@tempmee/react';
import { REFERRAL_TOAST_ANCHOR } from '../AuthRedesign/signUp/shared/ReferralLinkedToast/ReferralLinkedToast';

const LEGACY_REFERRAL_LINK_MESSAGE =
  'Link expired. Ask your friend for a new one.';
const AUTO_HIDE_MS = 3000;

export interface ILegacyReferralLinkToastProps {
  open: boolean;
  onClose: () => void;
}

export const LegacyReferralLinkToast = ({ open, onClose }: ILegacyReferralLinkToastProps) => (
  <Toast
    open={open}
    message={LEGACY_REFERRAL_LINK_MESSAGE}
    autoHideDuration={AUTO_HIDE_MS}
    anchorOrigin={REFERRAL_TOAST_ANCHOR}
    onClose={onClose}
  />
);
